import styled, { css, keyframes } from "styled-components";
export const Circle = styled.svg<{ break: boolean }>`
  position: absolute;
  transform: rotate(0.25turn);
  width: 856px;
  height: 856px;
  background-color: black;
  border-radius: 438px;
  box-shadow: ${({ break: isBreak }) =>
    !isBreak
      ? "0px 0px 43.57px 4.36px #FFFFFF80, 0px 0px 69.72px 4.36px #6436E7"
      : "none"};

  circle {
    fill: none;
    stroke-width: 25;
    stroke-linecap: round;
  }

  .background {
    stroke: rgba(240, 240, 240, 0.2);
  }

  .progress {
    stroke: ${({ break: isBreak }) => (!isBreak ? "#b2bce6" : "#DC0000")};
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;
export const Circle1 = styled(Circle)`
  width: 1012px;
  height: 1012px;
  border-radius: 506px;
  circle {
    fill: none;
    stroke-width: 30;
    stroke-linecap: round;
  }
`;
export const Timer1Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;
export const CircularProgress = styled.div<{ progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 812px;
  height: 812px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scaleX(-1);

  &::before {
    z-index: 999;
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(
      transparent ${(props) => 100 - props.progress}%,
      black ${(props) => 100 - props.progress}%
    );
  }
`;
export const CircularProgress1 = styled(CircularProgress)`
  width: 952px;
  height: 952px;
`;

export const Timer1BlindWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 100;
  margin-top: 20px;
  width: 1020px;
`;

export const Timer1Blind = styled.div`
  display: flex;
  width: 100%;
  height: 119px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.8);

  > .title {
    color: #fff;
    text-align: center;
    font-family: "Termina Test";
    font-size: 33px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .value {
    display: flex;
    flex-direction: row;
    gap: 10px;
    > .blind {
      color: #fff;
      text-align: center;
      font-family: "Termina Test";
      font-size: 50px;
      font-style: normal;
      font-weight: 900;
      line-height: 60.887px; /* 121.775% */
    }

    > .ante {
      color: #fff;
      font-family: "Termina Test";
      font-size: 42.621px;
      font-style: normal;
      font-weight: 900;
      line-height: 60.887px;
    }
  }
`;

export const Timer1NextBlind = styled(Timer1Blind)`
  > .title.next {
    color: #b3b3b3;
    text-align: center;
    font-family: "Termina Test";
    font-size: 25.32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    > .blind.next {
      color: #b3b3b3;
      text-align: center;
      font-family: "Termina Test";
      font-size: 42.001px;
      font-style: normal;
      font-weight: 900;
      line-height: 46.668px; /* 111.111% */
    }

    > .ante.next {
      color: #b3b3b3;
      font-family: "Termina Test";
      font-size: 32.668px;
      font-style: normal;
      font-weight: 900;
      line-height: 46.668px;
    }
  }
`;

export const Timer1PrizeWrapper = styled.div`
  z-index: 2;
  padding: 30px;
  box-sizing: border-box;
  width: 505px;
  height: 866px;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.25);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > img {
    position: absolute;
    bottom: 30px;
    left: 140px;
  }
`;

export const Timer1PrizeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-30%);
    opacity: 0;
  }
`;

export const Timer1PrizeItem = styled.div<{ length: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  ${({ length }) =>
    length >= 11 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer1PrizeItemTop3 = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;

  > .rank {
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Timer1NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value-wrapper {
    border-radius: 15.04px;
    background: #363636;
    width: 636px;
    height: 663px;
    padding: 20px;
    color: #fff;
    font-family: "Termina Test";

    > .value {
      width: 100%;
      height: 100%;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.3;
      overflow: hidden;
      text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
      overflow-wrap: break-word;
      display: -webkit-box; /* 웹킷 박스 모델로 설정 */
      -webkit-line-clamp: 17;
      -webkit-box-orient: vertical; /* 블록 방향 설정 */
    }
  }
`;

export const UserTimeWrapper1 = styled.div`
  padding: 30px 30px 35px;
  width: 1080px;
  height: 1920px;
  background: #363636;
  position: relative;
  box-sizing: border-box;

  > .background {
    background: #000000c4;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    top: 0;
    left: 0;
`;

export const Timer1InfoWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: -30px;
`;

export const Timer1LeftWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 505px;
`;

export const Timer1LeftItemWrapper = styled.div`
  position: relative;
  width: 505px;
  box-sizing: border-box;
  padding-left: 30px;
  height: 158px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  justify-content: center;
  background: #121212;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    color: #fff;
    font-family: "Termina Test";
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer1TimeWrapper = styled.div`
  margin-top: 14px;
  width: 1012px;
  height: 1012px;
  flex-shrink: 0;
  border-radius: 1012px;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 5;

  .dash-wrapper {
    position: absolute;
    top: 30px;
    width: 952px;
    height: 952px;
    > img {
      width: 952px;
      height: 952px;
    }
  }
`;

export const Timer1TimerBox = styled.div`
  margin-top: 104px;
  z-index: 1;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > .title-box {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 10px;

    > .pub-name {
      color: #fff;
      font-family: Pretendard;
      font-size: 30px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 22px;
    }

    > .header {
      display: flex;
      flex-direction: row;
      gap: 19px;
      align-items: center;
      > img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-radius: 100%;
      }
      > .info-row {
        display: flex;
        flex-direction: column;
        text-align: start;
        > .title {
          color: #fff;
          font-family: Pretendard;
          font-size: 40px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        > .type {
          color: #fff;
          font-family: Pretendard;
          font-size: 30px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }
    }

    > .title {
      color: #fff;
      font-family: Pretendard;
      font-size: 50px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
  > .level-break {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    > .now-level {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 733px;
      height: 94px;
      border-radius: 62.312px;
      background: rgba(255, 255, 255, 0.3);
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 45px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    > .now-level.break {
      color: #fff;
      background: #f00;
    }
  }

  > .time {
    text-align: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 260px;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 240px */
    letter-spacing: -9.6px;
    text-shadow: 0px 0px 50px rgba(255, 255, 255, 0.5), 0px 0px 80px #f00;
  }

  > .time.level {
    color: #fff;
    text-shadow: 0px 0px 30px rgba(255, 255, 255, 0.5), 0px 0px 80px #6436e7;
  }
`;

export const Timer1Notice = styled.div`
  position: relative;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  height: 115px; /* 고정 높이 */
  padding: 10px;
  border-radius: 16px;
  box-sizing: border-box;
  line-height: 1.1; /* 줄 간격 설정 */
  text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
  overflow-wrap: break-word;
  overflow: hidden; /* 내용이 넘치면 잘림 */
  display: -webkit-box; /* 웹킷 박스 모델로 설정 */
  -webkit-line-clamp: 4; /* 4줄로 제한 */
  -webkit-box-orient: vertical; /* 블록 방향 설정 */
  background: #363636;
`;
